import React, { useState, useEffect } from "react";
import "./progress-pill.scss";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

const ProgressPill = (props) => {
  const [progress, setProgress] = useState({ progress: 0, total: 0 });
  const [mode, setMode] = useState("normal");

  useEffect(() => {
    const start = new Date(props.start);
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setMilliseconds(0);

    const end = new Date(props.end);
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
    end.setMilliseconds(999);

    const now = new Date();
    now.setHours(23);
    now.setMinutes(59);
    now.setSeconds(59);
    now.setMilliseconds(999);

    const total = (end - start) / (1000 * 60 * 60 * 24);
    let current = (now - start) / (1000 * 60 * 60 * 24);
    current = Math.max(current, 0);

    let progress = Math.round((current / total) * 100) / 100;

    progress = Math.max(progress, 0.13);
    progress = progress > 0.9 && progress <= 1 ? 1 : progress;

    if (total <= 0) {
      progress = current;
    }

    progress = Math.max(progress, 0.13);
    if (now < start) progress = 0;

    if (progress > 1) {
      progress = 1;
    }

    setProgress({ progress, total });
    setMode(props.modal ? "modal" : "normal");
  }, [props.start, props.end, props.modal]);

  const getPillColour = () => {
    const diff = Math.round(
      progress.total - progress.progress * progress.total
    );
    //console.log(diff);
    if (diff >= 6) return "pill-green";
    else if (diff >= 3) return "pill-yellow";
    return "pill-red";
  };

  return (
    <>
      {props.sortBy.toLowerCase() === "upcoming due dates" ? (
        <div
          className={`${mode}-pill-width progress-pill d-flex align-items-center justify-content-center position-relative`}
        >
          <div className={`pill ${mode}-pill-width`}>
            <div
              className={`${
                progress.progress != 1 ? "pill-progress" : "pill"
              } ${getPillColour()}`}
              style={{ width: progress.progress * (props.modal ? 284 : 108) }}
            >
              {" "}
            </div>
          </div>
          <div className="pill-text">{formatDate(props.end)}</div>
        </div>
      ) : (
        <p>
          {Math.round(
            progress.total <= 0
              ? progress.progress
              : progress.progress * progress.total - progress.total
          )}
        </p>
      )}
    </>
  );
};

export default ProgressPill;
